import { render, staticRenderFns } from "./DashboardMetricChip.vue?vue&type=template&id=09d9e309"
import script from "./DashboardMetricChip.vue?vue&type=script&lang=js"
export * from "./DashboardMetricChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports